module.exports = __webpack_public_path__ + "201811/img/member_level_2.9eaa7fb8.png";